import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme, { columns }: { columns: number }) => ({
  container: {
    width: '100%',
    padding: `${theme.other.spacing._16}px 0`,
    marginTop: theme.other.spacing._16,
  },

  rewardTooltipTrack: {
    position: 'relative',
    top: 0,
    left: 0,
    height: '100%',
  },
  rewardTooltipPosition: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 0,
    height: 0,
  },
  rewardTooltip: {
    position: 'absolute',
    height: 24,
    bottom: 8,
    transform: 'translateX(calc(-50% - 6px))',
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    padding: `0 ${theme.other.spacing._8}px`,
    color: theme.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',

    '&.left': {
      left: 0,
      transform: 'translateX(-16px)',
    },
    '&.right': {
      right: 0,
      transform: 'translateX(0px)',
    },

    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: -4,
      right: 'calc(50% - 5px)',
      width: 10,
      aspectRatio: '1/cos(60deg)',
      clipPath: 'polygon(50% 100%,100% 0,0 0)',
      background: 'inherit',
    },

    '&.left:after': {
      right: 'auto',
      left: 10,
    },
    '&.right:after': {
      right: 10,
      left: 'auto',
    },
  },

  track: {
    position: 'relative',
    width: '100%',
    height: theme.other.spacing._16,
    backgroundColor: theme.colors.gray2[1],
    borderRadius: theme.radius.md,
    marginBottom: theme.other.spacing._12,
    overflow: 'hidden',
  },
  fill: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    height: '100%',
    transition: 'width 0.3s ease',
    borderRadius: theme.radius.md,
  },

  markersContainer: {
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
  },
  marker: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._4,

    '&.ctaMarker': {
      gridColumn: 'span 2',
      alignItems: 'flex-start',
      color: theme.colors.gray2[3],
    },
  },
  trackMarker: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 16,
    zIndex: 1000,
  },
  checkIcon: {
    color: theme.white,
  },
  percentBack: {
    color: theme.colors.gray2[3],
  },
  darkMarkerText: {
    color: theme.white,
  },
}));
